import {AGREEMENT_DATA} from "./agreementReducer";

export const getAgreementText = () => {
  return{
    type:AGREEMENT_DATA.AGREEMENT_DATA_REQUEST,
  }
};